import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { SkeletonPage } from "../components/Skeleton";

export function PrivacyContent() {
  const [copy, setCopy] = useState<{ summary: string; watermarks: string; retention: string } | null>(null);

  useEffect(() => {
    api<{ summary: string; watermarks: string; retention: string }>("/api/v1/privacy", { admin: false })
      .then(setCopy)
      .catch(console.error);
  }, []);

  if (!copy) return <SkeletonPage />;

  return (
    <>
      <h1 className="page-title">Privacy</h1>
      <p className="page-lead">{copy.summary}</p>
      <h2 className="privacy-heading">Watermarks</h2>
      <p className="muted">{copy.watermarks}</p>
      <h2 className="privacy-heading">Retention</h2>
      <p className="muted">{copy.retention}</p>
      <p className="muted">
        Data is stored in the EU (Cloudflare R2 EU jurisdiction). Access is logged for security and deal analytics.
      </p>
    </>
  );
}

/** Public privacy notice, no admin session required. */
export function PublicPrivacyPage() {
  return (
    <div className="public-privacy-shell">
      <article className="public-privacy-shell__card">
        <img className="public-privacy-shell__logo" src="/brand/spielmann-logo.svg" alt="Spielmann Consulting" />
        <PrivacyContent />
      </article>
    </div>
  );
}

/** Visitor privacy from a secure link; never enters the admin shell. */
export function VisitorPrivacyPage() {
  const { token = "" } = useParams();
  const roomPath = `/v/${encodeURIComponent(token)}`;

  return (
    <div className="viewer-shell">
      <article className="viewer-gate public-privacy">
        <p className="public-privacy__back">
          <Link to={roomPath}>← Back to dataroom</Link>
        </p>
        <PrivacyContent />
      </article>
    </div>
  );
}
